import type { ReactNode } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Icon from "@/v2-ui/icon"

const TONE_STYLE = {
  info: "border-border bg-muted/40 text-muted-foreground",
  warning: "border-amber-500/50 bg-amber-500/10",
  destructive: "border-destructive/50 bg-destructive/10 text-destructive",
} as const

const TONE_ICON = {
  info: "info",
  warning: "triangle-warning",
  destructive: "triangle-warning",
} as const

export type FeatureNoticeProps = {
  className?: string
  tone: keyof typeof TONE_STYLE
  children: ReactNode
}

/**
 * The standing explanation above a feature editor: why a field is missing,
 * where its real editor lives, what a save here will and will not reach.
 *
 * One shell for all of them so a reader learns the shape once — an inline
 * strip, never a dialog, because none of them interrupt the edit.
 */
function FeatureNotice(props: FeatureNoticeProps) {
  const { tone, children, className } = props

  return (
    <p
      className={cn(
        "flex items-start gap-1.5 rounded-md border px-2.5 py-1.5 text-xs",
        TONE_STYLE[tone],
        className,
      )}
    >
      <Icon src={TONE_ICON[tone]} size={12} className="mt-0.5 shrink-0" />
      <span>{children}</span>
    </p>
  )
}

export default FeatureNotice
